import { render, staticRenderFns } from "./AccettazioneSsnImpegnativaComponentN.vue?vue&type=template&id=1221f6b4&scoped=true"
import script from "./AccettazioneSsnImpegnativaComponentN.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnImpegnativaComponentN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1221f6b4",
  null
  
)

export default component.exports